import { hotkeys } from 'react-keyboard-shortcuts';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import withWidth from '@material-ui/core/withWidth';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import VerticalSplitIcon from '@material-ui/icons/VerticalSplit';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ENTITLEMENTS } from '../application-core/constants';
import GetStarted from '../application-core/GetStarted';
import ActionText from '../core/ActionText';
import CreateButton from '../core/CreateButton';
import ProjectLanguageSelector from '../core/ProjectLanguageSelector';
import { globalStyles } from '../core/style/gstheme';
import { PANEL_WIDTH_NORMAL, PANEL_WIDTH_WIDE } from '../core/utils/constants';
import { checkResourceEntitlements } from '../core/utils/utils';
import withGS from '../core/withGShoc';
import CreateNodeDialogContainer from './CreateNodeDialogContainer';
import CreateResourceDialog from './CreateResourceDialog';
import DatatypeData from './DatatypeData';
import ResourceSearch from './ResourceSearch';
import ResourceStructure from './ResourceStructure';

const styles = Object.assign({}, globalStyles);

function DatatypeCreateDialog(props) {

  return (
    <CreateNodeDialogContainer
      ontologyIRI={props.ontologyIRI}
      useSlashIRI={props.useSlashIRI}
      useUuidIRI={props.useUuidIRI}
      iriOptions={props.iriOptions}
      button={props.bigButton ? <CreateButton label="Add" /> : null}
      parentIRI={props.data.id}
      graph={props.graph}
      useWorkflow={props.useWorkflow}
      onlyComponentResources={true}
      onAddExistingNode={props.onAddExistingNode}
      onAddNewNode={props.onAddNewNode(props.titlePath, "")}
      disableMultiple={props.disableMultiple}
      searchClass={props.searchClass}
      searchClassFilter={[
        "http://www.w3.org/2002/07/owl#Class",
        "http://www.w3.org/2002/07/owl#AnnotationProperty",
        "http://www.w3.org/2002/07/owl#DatatypeProperty",
        "http://www.w3.org/2002/07/owl#ObjectProperty",
        "http://www.w3.org/2002/07/owl#NamedIndividual",
        "http://www.w3.org/2000/01/rdf-schema#Datatype"
      ]}
      exclude={[
        "https://graphifi.com/schema/xowl/topAnnotationProperty",
        "http://www.w3.org/2002/07/owl#topObjectProperty",
        "http://www.w3.org/2002/07/owl#topDataProperty",
        "http://www.w3.org/2002/07/owl#Thing"
      ]}
      createDialog={CreateResourceDialog}
      title="Add Datatype"
      placeholder="Enter label"
      name="Add a datatype (Alt+n)"
    />
  );
}

class DatatypeView extends Component {

  constructor(props) {
    super(props);
    this.infoRef = React.createRef();
    this.controlRef = React.createRef();
  }

  hot_keys = {
    'alt+i': {
      priority: 1,
      handler: () => {
        if (this.infoRef && this.infoRef.current) {
          this.infoRef.current.focus();
        }
      }
    },
    'alt+c': {
      priority: 1,
      handler: () => {
        if (this.controlRef && this.controlRef.current) {
          this.controlRef.current.focus();
        }
      }
    }
  };

  componentDidMount() {
    if (this.props.activeDatatype && this.props.data[this.props.childProperty])
      this.props.onFoundDatatype(this.props.data[this.props.childProperty])(this.props.activeDatatype);
  }

  render() {

    const { activeDatatype, classes, ontologyIRI, onSelect, onAddNewNode, expandNode, collapseNode, selectedTitlePath, onAddExistingNode,
      data, appBar, foundRef, defaultLang, foundPath, onFoundDatatype, childProperty, searchClass, buildLink, titlePath, viewLang,
      hiddenProps, viewWidth, width, onFullViewChange, onViewWidthChange, isFullView, availableAnnotationProperty, useSlashIRI, useUuidIRI,
      foundTime, onDeleteNode, expandedPaths, project, graph, onSelectViewLanguage, entitlements, projectUsers, useWorkflow,
      iriOptions, editingOptions, advancedView } = this.props;

    const isReadOnly = checkResourceEntitlements(data, ENTITLEMENTS.EDIT_ONTOLOGY);
    const isLargeScreen = width === "lg" || width === "xl";
    const panelWidth = advancedView ? PANEL_WIDTH_WIDE : PANEL_WIDTH_NORMAL;

    return (
      <div>
        <div className={classes.controlPanel}
          style={{
            ...(!isFullView && advancedView && viewWidth === 0) && { width: panelWidth },
            ...(isFullView) && { width: 'calc(100% - 100px)' },
            ...(!isFullView && isLargeScreen && viewWidth !== 0) && { width: (panelWidth + (viewWidth * 100)) }
          }}>
          <div className={classes.views}>
            {appBar}
          </div>
          <div className={classes.controlPanelInner}>
            <div className={classes.controlPanelAdd}>
              {!isReadOnly && data[childProperty] && data[childProperty].length > 0 ?
                <CreateNodeDialogContainer
                  ontologyIRI={ontologyIRI}
                  useSlashIRI={useSlashIRI}
                  useUuidIRI={useUuidIRI}
                  parentIRI={data.id}
                  graph={graph}
                  useWorkflow={useWorkflow}
                  onlyComponentResources={true}
                  iriOptions={iriOptions}
                  onAddExistingNode={onAddExistingNode}
                  onAddNewNode={onAddNewNode(titlePath, "")}
                  searchClass={searchClass}
                  searchClassFilter={[
                    "http://www.w3.org/2002/07/owl#Class",
                    "http://www.w3.org/2002/07/owl#AnnotationProperty",
                    "http://www.w3.org/2002/07/owl#DatatypeProperty",
                    "http://www.w3.org/2002/07/owl#ObjectProperty",
                    "http://www.w3.org/2002/07/owl#NamedIndividual",
                    "http://www.w3.org/2000/01/rdf-schema#Datatype"
                  ]}
                  createDialog={CreateResourceDialog}
                  existing={data[childProperty]}
                  exclude={
                    [
                      "https://graphifi.com/schema/xowl/topAnnotationProperty",
                      "http://www.w3.org/2002/07/owl#topObjectProperty",
                      "http://www.w3.org/2002/07/owl#topDataProperty",
                      "http://www.w3.org/2002/07/owl#Thing"
                    ]}
                  title="Add Datatype"
                  placeholder="Enter datatype label"
                  name="Add a datatype (Alt+n)"
                />
                :
                <span style={{ width: 30 }}>&nbsp;</span>
              }
            </div>
            <div className={advancedView ? classes.controlPanelSearchWide : classes.controlPanelSearch}>
              {data[childProperty] && data[childProperty].length > 0 &&
                <ResourceSearch
                  searchClass={searchClass}
                  graph={graph}
                  title="Find a datatype"
                  ontologyIRI={ontologyIRI}
                  onFoundResource={onFoundDatatype(data[childProperty])}
                  defaultLang={viewLang || defaultLang} />
              }
            </div>
          </div>
          <div data-test="datatype-tree" tabIndex={0} ref={this.controlRef}
            className={classes.deepTree}
            style={
              {
                ...(advancedView && viewWidth === 0) && { width: panelWidth },
                ...(isFullView) && { width: 'calc(100% - 100px)' },
                ...(!isFullView && isLargeScreen && viewWidth !== 0) && { width: (panelWidth + (viewWidth * 100)) }
              }
            }>
            {data[childProperty] && data[childProperty].length > 0 &&
              <div className={advancedView ? classes.treeOptionsWide : classes.treeOptions}>
                <div data-test="editing-mode" style={{ paddingTop: 4, paddingBottom: 4, overflow: 'auto' }}>
                  <Tooltip title="Toggle full view mode">
                    <span data-test={"full-view"} onClick={onFullViewChange} style={{ float: 'right', marginLeft: 4 }}>
                      <IconButton data-test={"option-full-view"} size="small">
                        {isFullView ?
                          <FullscreenExitIcon />
                          :
                          <FullscreenIcon />
                        }
                      </IconButton>
                    </span>
                  </Tooltip>
                  {isLargeScreen &&
                    <Tooltip title="Change view width">
                      <span data-test={"split-view-" + viewWidth} onClick={onViewWidthChange} style={{ float: 'right' }}>
                        <IconButton data-test={"option-split"} size="small">
                          <VerticalSplitIcon />
                        </IconButton>
                      </span>
                    </Tooltip>
                  }
                </div>
              </div>
            }
            {data[childProperty] && data[childProperty].length > 0 ?
              <ResourceStructure
                filter={true}
                isReadOnly={true}
                useWorkflow={useWorkflow}
                defaultLang={defaultLang}
                foundPath={foundPath}
                foundRef={foundRef}
                buildLink={buildLink}
                graph={graph}
                iriOptions={iriOptions}
                activeResource={activeDatatype}
                titlePath={titlePath}
                titleTree={[]}
                viewLang={viewLang}
                selectedTitlePath={selectedTitlePath}
                foundTime={foundTime}
                childProperty={childProperty}
                expandedPaths={expandedPaths}
                onAddExistingNode={onAddExistingNode}
                onAddNewNode={onAddNewNode && searchClass !== "http://www.w3.org/2000/01/rdf-schema#Datatype" ? onAddNewNode : null}
                onDeleteNode={onDeleteNode}
                expandNode={expandNode}
                collapseNode={collapseNode}
                ontologyIRI={ontologyIRI}
                useSlashIRI={useSlashIRI}
                useUuidIRI={useUuidIRI}
                data={data}
                path=""
                onSelect={onSelect}
                searchClass={searchClass}
                searchClassFilter={[
                  "http://www.w3.org/2002/07/owl#Class",
                  "http://www.w3.org/2002/07/owl#DatatypeProperty",
                  "http://www.w3.org/2002/07/owl#AnnotationProperty",
                  "http://www.w3.org/2002/07/owl#ObjectProperty",
                  "http://www.w3.org/2002/07/owl#NamedIndividual"
                ]}
                permissions={[ENTITLEMENTS.EDIT_ONTOLOGY]}
                createDialog={CreateResourceDialog}
                addTitle="Add Datatype"
                emptyLevel="No datatypes."
              />
              :
              isReadOnly ?
                <ActionText offset="85px">No datatypes.</ActionText>
                :
                <GetStarted text="Add a datatype to get started." action={
                  <DatatypeCreateDialog bigButton={true} disableMultiple={true} {...this.props} />
                } />
            }
          </div>
        </div>
        <div data-test="language-panel" className={classes.viewLanguagePanel}>
          <ProjectLanguageSelector selectedLang={viewLang} includeLabel={false} onSelect={onSelectViewLanguage} />
        </div>
        {!isFullView &&
          <div data-test="info-panel" ref={this.infoRef} tabIndex={0}
            className={classes.infoPanel}
            style={
              {
                ...(!isFullView && viewWidth === 0) && { left: panelWidth + 40 },
                ...(!isFullView && viewWidth !== 0) && { left: ((panelWidth + 40) + (viewWidth * 100)) }
              }
            }>
            {
              data[childProperty] && data[childProperty].length > 0 ?
                (
                  activeDatatype === null ?
                    <ActionText offset="180px">Select a datatype to view the detail.</ActionText>
                    :
                    <DatatypeData
                      key={activeDatatype}
                      project={project}
                      availableAnnotationProperty={availableAnnotationProperty}
                      entitlements={entitlements}
                      projectUsers={projectUsers}
                      useWorkflow={useWorkflow}
                      graph={graph}
                      editingOptions={editingOptions}
                      hiddenProps={hiddenProps}
                      viewLang={viewLang}
                      buildLink={buildLink}
                      searchClass={searchClass}
                      datatypeIRI={activeDatatype}
                      ontologyIRI={ontologyIRI}
                      onDeleteDatatype={onDeleteNode} />
                )
                :
                <ActionText offset="180px">When datatypes are created you will be able to view the detail here.</ActionText>
            }
          </div>
        }
      </div>
    );
  }
}

DatatypeView.defaultProps = {
  viewWidth: 0
};

DatatypeView.propTypes = {
  classes: PropTypes.object,
  entitlements: PropTypes.array.isRequired,
  projectUsers: PropTypes.array,
  buildLink: PropTypes.func.isRequired,
  defaultLang: PropTypes.string.isRequired,
  searchClass: PropTypes.string.isRequired,
  ontologyIRI: PropTypes.string.isRequired,
  useSlashIRI: PropTypes.bool,
  useUuidIRI: PropTypes.bool,
  activeDatatype: PropTypes.string,
  graph: PropTypes.string.isRequired,
  titlePath: PropTypes.array.isRequired,
  childProperty: PropTypes.string.isRequired,
  selectedTitlePath: PropTypes.array,
  expandNode: PropTypes.func.isRequired,
  collapseNode: PropTypes.func.isRequired,
  onAddExistingNode: PropTypes.func.isRequired,
  onAddNewNode: PropTypes.func.isRequired,
  onDeleteNode: PropTypes.func.isRequired,
  onFoundDatatype: PropTypes.func.isRequired,
  viewLang: PropTypes.string,
  foundPath: PropTypes.string,
  onSelectViewLanguage: PropTypes.func,
  foundTime: PropTypes.number,
  foundRef: PropTypes.object,
  project: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  isFullView: PropTypes.bool,
  viewWidth: PropTypes.number,
  onCollapse: PropTypes.func,
  onFullViewChange: PropTypes.func.isRequired,
  onViewWidthChange: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  useWorkflow: PropTypes.bool,
  availableAnnotationProperty: PropTypes.array,
  hiddenProps: PropTypes.array,
  editingOptions: PropTypes.array,
  iriOptions: PropTypes.object
};

export default withWidth()(withStyles(styles)(withGS(hotkeys(DatatypeView))));